module.exports = __webpack_public_path__ + "static/media/19ESCAP30.7e5f57ed.jpg";